(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/game/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/casino/game/assets/javascripts/utils.js');

'use strict';

const isServer = typeof exports === 'object';
let logger;
let contentApi;
let apiUtils;
let trinidad;
let statsConstants;
let site;
let stats;
let formatGame;
if (isServer) {
  const root = process.cwd();
  const path = require('path');
  trinidad = require('@svenskaspelab/trinidad-core').core;
  statsConstants = require(path.join(root, 'stats-constants'));
  site = trinidad.config.options.site;
  stats = trinidad.stats;
  logger = trinidad.logger('component:casino:game');
  const sharedContent = trinidad.components.require('content', 'shared');
  contentApi = sharedContent.api;
  apiUtils = sharedContent.apiUtils;
  formatGame = trinidad.components.require('casino', 'format-game').formatGame;
} else {
  var _svs$content, _svs$components;
  logger = svs.core.log.getLogger('component:casino:game');
  contentApi = (_svs$content = svs.content) === null || _svs$content === void 0 || (_svs$content = _svs$content.shared) === null || _svs$content === void 0 ? void 0 : _svs$content.cms;
  formatGame = (_svs$components = svs.components) === null || _svs$components === void 0 || (_svs$components = _svs$components.casino) === null || _svs$components === void 0 ? void 0 : _svs$components.formatGame;
}
const FEATURE_TOGGLE_CMS_API_CLIENT = 'ft-use-cms-api-client-lb';
function placeholderGame(gameName) {
  let favorite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return {
    name: gameName,
    title: gameName.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase()),
    disabled: true,
    favorite
  };
}
async function getGameByCmsId() {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let req = arguments.length > 1 ? arguments[1] : undefined;
  if (!(await req.feature(FEATURE_TOGGLE_CMS_API_CLIENT))) {
    return new Promise((resolve, reject) => {
      contentApi.id({
        req,
        id
      }, (err, data) => {
        if (err) {
          reject(err);
        } else {
          resolve(formatGame(data.result[0]));
        }
      });
    });
  }
  const client = apiUtils.getCmsClient(req);
  const data = await client.v1.content.getByIds({
    ids: id
  });
  return formatGame(data.result[0]);
}

async function getGameByCmsIdClient() {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const useLegacyJupiterApi = !svs.core.detect.feature(FEATURE_TOGGLE_CMS_API_CLIENT);
  if (useLegacyJupiterApi) {
    return new Promise((resolve, reject) => {
      contentApi.getContentById({
        id
      }, (err, data) => {
        if (err) {
          reject(err);
        } else {
          resolve(formatGame(data.result[0]));
        }
      });
    });
  }
  const client = svs.content.shared.getCmsClient();
  const data = await client.v1.content.getByIds({
    ids: id
  });
  return formatGame(data.result[0]);
}
async function getArticleByCmsId() {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let req = arguments.length > 1 ? arguments[1] : undefined;
  if (!(await req.feature(FEATURE_TOGGLE_CMS_API_CLIENT))) {
    return new Promise((resolve, reject) => {
      contentApi.id({
        req,
        id
      }, (err, data) => {
        if (err || !data.result) {
          reject(err);
        } else {
          resolve(data.result[0]);
        }
      });
    });
  }
  const client = apiUtils.getCmsClient(req);
  const data = await client.v1.content.getByIds({
    ids: id
  });
  return data.result[0];
}

async function getAllGames(req) {
  if (!(await req.feature(FEATURE_TOGGLE_CMS_API_CLIENT))) {
    return new Promise((resolve, reject) => {
      const queryFn = contentApi.basicFilter;
      const queryOptions = {
        req,
        type: 'cnt:casinoGame',
        count: 3000,
        offset: 0
      };
      queryFn(queryOptions, (err, data) => {
        if (err) {
          reject(err);
        } else {
          resolve(data.result || []);
        }
      });
    });
  }
  const client = apiUtils.getCmsClient(req);
  return client.v1.content.filter({
    contentTypes: 'cnt:casinoGame',
    count: 3000,
    offset: 0
  }).then(data => data.result || []);
}

async function getLaunchParameters(req, name, demo, urlParams, sessionTime) {
  urlParams = urlParams || {};
  const jupiterOptions = {
    req,
    res: req.res,
    method: 'GET',
    path: "/casino/1/launchparameters?name=".concat(encodeURIComponent(name), "&device=").concat(deviceType(req), "&demo=").concat(demo)
  };
  const defaultGeoIp = {
    country: 'SE',
    whitelisted: false
  };
  try {
    var _geoIpResponse, _geoIpResponse2;
    let geoIpResponse;
    const geoipLookup = new trinidad.geoipLookup();
    geoIpResponse = await geoipLookup.lookupIp(req);
    if (!geoIpResponse.country) {
      geoIpResponse = defaultGeoIp;
    }
    if ((_geoIpResponse = geoIpResponse) !== null && _geoIpResponse !== void 0 && _geoIpResponse.country) {
      jupiterOptions.path += "&country=".concat(geoIpResponse.country);
    }
    if (typeof ((_geoIpResponse2 = geoIpResponse) === null || _geoIpResponse2 === void 0 ? void 0 : _geoIpResponse2.whitelisted) === 'boolean') {
      jupiterOptions.path += "&whitelisted=".concat(geoIpResponse.whitelisted);
    }
    stats.increment(statsConstants.casino[site].counters.GEOIP_LOOKUP_SUCCESS);
  } catch (error) {
    logger.error("GeoIP lookup failed for launch parameters. Defaulting to Sweden (SE) to allow game launch. Error:", error, req);
    stats.increment(statsConstants.casino[site].counters.GEOIP_LOOKUP_ERROR);
    jupiterOptions.path += "&country=".concat(defaultGeoIp.country, "&whitelisted=").concat(defaultGeoIp.whitelisted);
  }
  if (sessionTime !== undefined) {
    jupiterOptions.path += "&sessionTime=".concat(sessionTime);
  }
  Object.keys(urlParams).forEach(param => {
    jupiterOptions.path += "&".concat(param, "URL=").concat(encodeURIComponent(urlParams[param]));
  });
  return await trinidad.internalJupiter.callAsync(jupiterOptions);
}

function deviceType(req) {
  let device = req.capabilities.formFactor;
  if (device === 'desktop' && (req.capabilities.os === 'iphone os' || req.capabilities.os === 'android')) {
    device = 'tablet';
  } else if (req.capabilities.os === 'os x') {
    const devices = {
      desktop: 'desktop',
      mobile: 'mobile',
      tablet: 'tablet',
      undefined: 'desktop'
    };
    device = devices[req.cookies.casinodevicetype];
  }
  return device;
}
if (isServer) {
  module.exports = {
    getGameByCmsId,
    getArticleByCmsId,
    placeholderGame,
    getAllGames,
    getLaunchParameters,
    deviceType
  };
} else {
  svs.components.casino.game = {
    getGameByCmsIdClient
  };
}

 })(window);